/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ig-card-action{display:block;cursor:pointer;padding:.5rem;border-bottom:1px solid #d3d3d3;text-align:center}ig-card-action:hover{background-color:#5cbcff;color:#fff}ig-card-action .mat-icon{margin:0;font-size:20px;vertical-align:middle;display:inline-block;color:#3b6dac}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/water.fall.container/card/action/card.action.component.scss.ngstyle.js.pre-build-optimizer.js